import React, { CSSProperties, PropsWithChildren } from 'react';

import usePolicy from '@/hooks/usePolicy.ts';
import UIConfig from '@/UIConfig.ts';
import { useProfileStore } from '@/store/useProfileStore.ts';

const CardPlaceholder: React.FC<PropsWithChildren & { zIndex?: number }> = ({
  children,
  zIndex = 1
}) => {
  const { isBeingVerified } = usePolicy();
  const { isSkipCompleteProfilePlaceholder, isProfileFullyCompleted } =
    useProfileStore();

  return (
    <div style={{ ...cardStyles, zIndex }}>
      <div
        style={{
          ...contentStyle,
          background: isBeingVerified
            ? isSkipCompleteProfilePlaceholder || isProfileFullyCompleted()
              ? '#8284FF'
              : UIConfig.Colors.CompleteProfileGradient
            : UIConfig.Card.Content.background
        }}
      >
        <div style={{ width: '100%', height: '100%', position: 'relative' }}>
          {children}
        </div>
      </div>
    </div>
  );
};

const contentStyle: CSSProperties = {
  width: 'calc(100% - 25px)',
  height: 'calc(100% - 25px)',
  borderRadius: '35px',
  position: 'relative',
  marginTop: '0px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
};

const cardStyles: CSSProperties = {
  position: 'absolute',
  width: '100%',
  height: 'calc(100vh - 180px)',
  marginTop: '100px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  touchAction: 'none',
  borderRadius: '35px',
  overflow: 'hidden',
  zIndex: 1
};

export default CardPlaceholder;